module.exports = __webpack_public_path__ + "img/热.103551fa.png";